<template>
	<v-dialog v-model="dialog" :max-width="options.width" @keydown.esc="cancel">
		<v-card>
			<v-card-title>{{ title }}</v-card-title>
			<v-card-text v-if="message" v-html="$sanitize(message)"></v-card-text>
			<v-card-text>
				<v-btn class="confirm" @click="agree" style="margin-right: 16px;">{{ $t('docs.delete.yes') }}</v-btn>
				<v-btn class="cancel" @click="cancel">{{ $t('docs.delete.cancel') }}</v-btn>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data: () => ({
		dialog: false,
		resolve: null,
		reject: null,
		message: null,
		title: null,
		options: {
			color: 'error',
			width: 460
		}
	}),
	methods: {
		open (title, message, options) {
			this.dialog = true;
			this.title = title;
			this.message = message;
			this.options = Object.assign(this.options, options);
			return new Promise((resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;
			});
		},
		agree () {
			this.resolve(true);
			this.dialog = false;
		},
		cancel () {
			this.resolve(false);
			this.dialog = false;
		}
	}
};
</script>
<style>
.cancel {
	margin: 6px;
	font-family: "IBM Plex Sans", monospace;
	font-size: 16px;
	text-transform: none;
	text-indent: 0px;
	letter-spacing: 0em;
	font-weight: bold;
	padding-left: 16px !important;
	padding-right: 16px !important;
}

.confirm {
	margin: 6px;
	font-family: "IBM Plex Sans", monospace;
	font-size: 16px;
	text-transform: none;
	text-indent: 0px;
	letter-spacing: 0em;
	font-weight: bold;
	padding-left: 16px !important;
	padding-right: 16px !important;
	background-color: #E50051 !important;
	color: white !important;
}

</style>
